import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import VisibilityIcon from "@material-ui/icons/Visibility";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import Link from "next/link";
import { useRouter } from "next/router";
import Skeleton from "@material-ui/lab/Skeleton";

export default function AuthorCardskeleton(props) {
  
  
  return (
    <>
     <div  className="turning-screens music-artists 2xl:w-2/12 xl:w-5/12 lg:w-3/12 md:w-4/12  "
                  >
      <div className="author">
        
          <a
            style={{ display: "flex", width: "100%", flexDirection: "column" }}
          >
            <div
              className="author__cover author__cover--bg" style={{backgroundColor:"transparent!important"}}
               
            >
             <Skeleton animation="wave" height={120} width="100%" style={{
                     borderTopLeftRadius: "15px",
                     borderTopRightRadius: "15px"
             }} />

            </div>
          </a>
        <div className="author__meta">
            <a style={{ display: "block" }}>
              <>
                <div
                  className={
                    "author__avatar" 
                  }
                  style={{
                    borderTopRightRadius:"15px",
                    borderTopLeftRadius: "15px"
                }}
                >
                  <Skeleton animation="wave" height={60} width="100%" />
                  
                </div>
                {/* <h3 className="author__name text_in_one_line">
                  {props.ele.name
                    ? props.ele.name.length > 12
                      ? props.ele.name.substring(0, 12) + "..."
                      : props.ele.name
                    : "-"}
                </h3> */}
                <h3 className="author__nickname">
                  
                  <Skeleton animation="wave" height={15} width="100%" style={{width:"100px"}} />
                </h3>
                <p className="author__text author-bio">
                <Skeleton animation="wave" height={12} width="100%"  style={{width:"150px"}} />
                </p>
              </>
            </a>

        </div>
      </div>
      </div>
    </>
  );
}
